import { Link } from 'react-router-dom';

export function AwaitingOrganizationPage() {
  return <section className="content-card">
    <h1>Awaiting organisation access</h1>
    <p>Your BFC account is ready, but you do not have active organisation access yet.</p>
    <p>Ask your organisation administrator to add your existing account using the same email address. Signing up does not create an organisation or grant a role.</p>
    <p>Selected the wrong signup path? Ask a platform administrator to correct your account type.</p>
    <div className="confirmation-actions">
      <Link className="button secondary" to="/profile">My profile</Link>
      <button className="button primary" type="button" onClick={() => window.location.reload()}>Refresh access</button>
    </div>
  </section>;
}
